import { Navigate, type RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Stores from "../pages/stores/page";
import FAQ from "../pages/faq/page";
import Blog from "../pages/blog/page";
import BlogArticle from "../pages/blog/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/stores",
    element: <Stores />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/channels",
    element: <Navigate to="/stores" replace />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
